package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val badge = Bem("admin-badge")

/** The badge variants of the design system: the visibility on the public site, an account's state, a hidden sponsor, something still to do, a board member, something only the new website shows and a plain tag. */
enum class BadgeVariant(internal val modifier: String) {
    PUBLIC("public"),
    PLANNED("planned"),
    EXPIRED("expired"),
    BOARD("board"),
    ACTIVE("active"),
    PENDING("pending"),
    INACTIVE("inactive"),
    HIDDEN("hidden"),
    ATTENTION("attention"),
    BETA("beta"),
    TAG("tag"),
}

/** A short status word in a pill. Colour is never the only signal, so [text] is always one of the fixed words. */
@Composable
fun AdminBadge(text: String, variant: BadgeVariant, extraClass: String? = null) {
    Span({ classes(*listOfNotNull(badge.block, badge.modifier(variant.modifier), extraClass).toTypedArray()) }) {
        Text(text)
    }
}

/** What a [BetaBadge] says to screen readers and as its tooltip. */
const val BETA_EXPLANATION = "Nur auf der neuen Website (Beta) sichtbar"

/**
 * "Beta" after the label of something only the new public site shows until the switch-over (#144): a nav entry, a
 * page, card or group title, a field label, a column header or a legend. Screen readers hear [BETA_EXPLANATION] as
 * part of that label. The switch-over (#115) removes every one of them, so they stay easy to find.
 */
@Composable
fun BetaBadge() {
    Span({
        classes(badge.block, badge.modifier(BadgeVariant.BETA.modifier))
        attr("title", BETA_EXPLANATION)
    }) {
        Span({ attr("aria-hidden", "true") }) { Text("Beta") }
        Span({ classes("admin-visually-hidden") }) { Text(BETA_EXPLANATION) }
    }
}
